import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/")({
  head: () =>
    pageHead({
      path: "/blog",
      title: "Blog CMO Partner | Fractional CMO, CRM et stratégie marketing PME",
      description:
        "Guides pratiques de CMO Partner : Fractional CMO, tarifs et formats, CRM HubSpot et Salesforce, stratégie marketing pour PME et ETI à Bordeaux et partout en France.",
      enPath: null,
      crumbs: [["Blog", "/blog"]],
    }),
  component: Blog,
});
